import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { alertReducers } from './alert.reducer';
import { ALERT_SLICE } from './alert.state';

@NgModule({
  imports: [StoreModule.forFeature(ALERT_SLICE, alertReducers)],
})
export class AlertStoreModule {}
